// components/sections/home/Services.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { Server, HardDrive, Shield, Cpu } from 'lucide-react';
import Container from '../../layout/Container';
import SectionHeading from '../../common/SectionHeading';
import Card from '../../common/Card';

const servicesData = [
  {
    icon: HardDrive,
    title: 'Hardware Solutions',
    description: 'Comprehensive hardware solutions tailored to your business needs with multi-brand support.',
  },
  {
    icon: Server,
    title: 'IT Infrastructure',
    description: 'Building efficient and scalable IT infrastructure for modern business requirements.',
  },
  {
    icon: Shield,
    title: 'Maintenance Contracts',
    description: 'Proactive maintenance services to ensure your IT systems run smoothly with minimal downtime.',
  },
  {
    icon: Cpu,
    title: 'Technical Consultation',
    description: 'Expert consultation to help you make informed decisions about your IT investments.',
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const Services = () => {
  return (
    <section className="py-20 bg-white">
      <Container>
        <SectionHeading
          title="Our Core Services"
          subtitle="We provide comprehensive IT solutions to help your business thrive in the digital era."
          center
        />
        
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {servicesData.map((service, index) => (
            <motion.div key={index} variants={item}>
              <Card
                icon={service.icon}
                title={service.title}
                description={service.description}
                hover
                className="h-full"
              />
            </motion.div>
          ))}
        </motion.div>
      </Container>
    </section>
  );
};

export default Services;